"use client";

import { useState } from "react";
import { Input } from "@heroui/react";
import { IAirdropTaskRender } from "@/types/task-renderer.types";
import { ChallengeCampaignEventState } from "@/types/challenges.types";
import { QuestTaskButton } from "../QuestTaskButton";

export const SecretCodeRenderer = ({
  task,
  completeTaskMutation,
  campaign,
}: IAirdropTaskRender) => {
  const [secretCode, setSecretCode] = useState(task.extraArguments?.[0] || "");

  const isDisabled =
    task.status === ChallengeCampaignEventState.PENDING ||
    task.status === ChallengeCampaignEventState.SUCCESSFUL ||
    !!task.cooldown ||
    completeTaskMutation.isPending;

  return (
    <>
      {/* Input and Claim Button - Mobile: stacked, Desktop: same row */}
      <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
        <div className="flex-1">
          <Input
            disabled={
              task.status !== ChallengeCampaignEventState.ERROR || isDisabled
            }
            type="text"
            value={secretCode}
            onValueChange={setSecretCode}
            placeholder="Enter secret code..."
            variant="bordered"
            classNames={{
              inputWrapper: "border-green-500/30 bg-green-900/20 hover:border-green-500/50 focus-within:border-green-500 transition-colors duration-200 rounded-2xl",
              input: "text-white placeholder:text-gray-400 px-3 py-2",
            }}
          />
        </div>
        <div className="flex-shrink-0">
          <QuestTaskButton
            buttonText="Claim"
            taskMutation={completeTaskMutation}
            className="mt-0 w-full sm:w-auto"
            task={task}
            onClick={() => {
              completeTaskMutation.mutateAsync({
                campaignId: campaign.id,
                groupId: campaign.campaignGroup,
                taskName: task.taskName,
                extraArguments: [secretCode],
                taskGuid: task.taskGuid,
              });
            }}
          />
        </div>
      </div>
    </>
  );
};
